import { Component, ViewChild } from '@angular/core';
import { ModalDirective } from "ngx-bootstrap/modal";
import { LocalDate } from "@js-joda/core";
import { DateRange, DateConversion } from "../../shared/date/date-range";
import { AbstractDownloadFileContentComponent } from '../../shared/download-file-content/abstract-download-file-content.component';
import { DateRangeComponent } from '../../shared/date/date-range-selector.component';

@Component({
    template: '',
    host: {
        'class' : 'download-file-content-modal'
      }    
  })
export class DownloadFileContentModal extends AbstractDownloadFileContentComponent {
    @ViewChild('recordsModal', {static: false}) public recordsModal: ModalDirective;
    @ViewChild(DateRangeComponent, {static: false}) public dateRangeSelector: DateRangeComponent;

    constructor(){
        super();
        let currentDate = DateConversion.localDateToStartOfDayJsLocal(LocalDate.now());
        this.startDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
        this.endDate = currentDate;
    }

    title: string = "";
    hideSpinner: boolean=true;
    public dateRange: DateRange;
    public startDate: Date;
    public endDate: Date;
    public minDate: Date;
    public maxDate: Date;
    showInvoiceNumbers: boolean = false;
    invoiceNumbers: string = '';
    showDateRangeSelector: boolean = false;
    promptText: string = "";
    public isValidDateRange: boolean;
    
    show() {
        if (this.dateRangeSelector) {
            this.dateRangeSelector.validateDateRange();
        }

        this.recordsModal.show();
    }

    public onDateRangeSelection(range: DateRange) {
        this.dateRange = range;
    }

	onDateRangeValidated(value: boolean) {
        this.isValidDateRange = value;
    }

    canGenerateContent(): boolean{
        return this.hideSpinner &&  (!this.showDateRangeSelector  || this.isValidDateRange);
    }

    closeModal(){
        this.hideSpinner = true;
        this.recordsModal.hide();
        this.ngOnDestroy();
    }
}
